import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

// Bootstrap + Tailwind
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
import './assets/tailwind.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import '@fortawesome/fontawesome-free/css/all.css'


// AOS Animations
import AOS from 'aos'
import 'aos/dist/aos.css'

const app = createApp(App)

app.use(router)

app.mount('#app')

// Inicia AOS
AOS.init({
  duration: 700, // velocidad animaciones
  once: false,   // true = solo una vez, false = cada vez que entra en pantalla
  offset: 80     // distancia para activar animación
})
